import * as React from "react"

const SvgCreditCard = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M22 6.429v12q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.587H4q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 18.428v-12q0-.824.587-1.412A1.93 1.93 0 0 1 4 4.429h16q.824 0 1.413.587.587.588.587 1.413m-18 2h16v-2H4zm0 4v6h16v-6z" />
  </svg>
)
export default SvgCreditCard
